import { render, staticRenderFns } from "./FrenchWindowDescription.vue?vue&type=template&id=735fc720&scoped=true"
import script from "./FrenchWindowDescription.vue?vue&type=script&lang=ts"
export * from "./FrenchWindowDescription.vue?vue&type=script&lang=ts"
import style0 from "./FrenchWindowDescription.vue?vue&type=style&index=0&id=735fc720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735fc720",
  null
  
)

export default component.exports